// extracted by mini-css-extract-plugin
export var divider = "_m3-0";
export var systemMessage = "_m3-1";
export var systemMessageWrapper = "_m3-2";